import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './Home';
import Campaigns from './Campaigns';
import Recipients from './Recipients';
import SenderEmails from './SenderEmails';
import EmailLogs from './EmailLogs';
import Signatures from './Signatures';
import LeadFinder from './LeadFinder';
import Settings from './Settings';

function Dashboard({ onLogout }) {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="app-container">
      <aside className="sidebar">
        <div className="sidebar-header">
          <h2>邮件营销系统</h2>
          <p>管理面板</p>
        </div>

        <nav>
          <ul className="sidebar-nav">
            <li>
              <Link to="/" className={isActive('/')}>
                📊 仪表盘
              </Link>
            </li>
            <li>
              <Link to="/campaigns" className={isActive('/campaigns')}>
                📧 营销活动
              </Link>
            </li>
            <li>
              <Link to="/recipients" className={isActive('/recipients')}>
                👥 收件人管理
              </Link>
            </li>
            <li>
              <Link to="/lead-finder" className={isActive('/lead-finder')}>
                🔍 线索查找器
              </Link>
            </li>
            <li>
              <Link to="/sender-emails" className={isActive('/sender-emails')}>
                ✉️ 发件邮箱
              </Link>
            </li>
            <li>
              <Link to="/signatures" className={isActive('/signatures')}>
                ✍️ 邮件签名
              </Link>
            </li>
            <li>
              <Link to="/email-logs" className={isActive('/email-logs')}>
                📝 邮件日志
              </Link>
            </li>
            <li>
              <Link to="/settings" className={isActive('/settings')}>
                ⚙️ 设置
              </Link>
            </li>
          </ul>
        </nav>

        <div className="sidebar-footer">
          <button onClick={onLogout} className="logout-btn">
            退出登录
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/recipients" element={<Recipients />} />
          <Route path="/lead-finder" element={<LeadFinder />} />
          <Route path="/sender-emails" element={<SenderEmails />} />
          <Route path="/signatures" element={<Signatures />} />
          <Route path="/email-logs" element={<EmailLogs />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </main>
    </div>
  );
}

export default Dashboard;

